import React from "react";

import { Container, Row, Col } from "../Base/Layout";
import SectionTitle from "../Base/SectionTitle";
import Button from "../Base/Button";
import { IoMdCheckmark, IoMdClose } from "react-icons/io";

import particle1 from "../../../assets/particles/14.png";
import particle2 from "../../../assets/particles/15.png";

import data from "../../../assets/pricing";

import PricingSectionWrapper from "./pricingSection.style";

import { useRouter } from "next/router";

import { FiMail } from "react-icons/fi";

const PriceBlock = ({pricing, index, onClick}) => {
  return (
    <Col xs={12} sm={6} lg={4} key={index}>
      <div className="pricing-block">
        <div className="thumb-block">
          <img style={{objectFit: 'contain', height: '100%'}} src={pricing.thumb} alt="appion app landing" />
        </div>
        <div className="price-block">
          <h3>{pricing.price} <span style={{fontSize: '16px'}}>/ month</span></h3>
          <p>{pricing.name}</p>
        </div>
        <p>{pricing.description}</p>
        <div className="details-block" style={{marginBottom: '32px'}}>
          {pricing.services.map((service, index) => (
            <span className={service.className} key={index}>
              {service.className == "on" ? (
                <IoMdCheckmark />
              ) : (
                <IoMdClose />
              )}
              {service.content}
            </span>
          ))}
        </div>
        <Button className="pricing-btn" onClick={onClick}>{pricing.btnText}</Button>
      </div>
    </Col>
  )
}
export { PriceBlock }

const Pricing = () => {
  const router = useRouter()
  return (
    <PricingSectionWrapper id="pricing">
      <img className="section__particle one" src={particle1} alt="img" />
      <img className="section__particle two" src={particle2} alt="img" />
      <Container>
        <SectionTitle UniWidth="65%">
          <h4>Pricing</h4>
          <h2>
            Plans from <span>free to scale</span>
          </h2>
        </SectionTitle>
        <Row>
          {data.pricings.map((pricing, index) => <PriceBlock pricing={pricing} index={index} onClick={() => router.push('/app')}/>)}
        </Row>
        <div style={{marginTop: 60, padding: '0 40px'}}>
          For enterprise request and custom inquiries get in touch on 
          <a href="mailto:contact@ondiagram.com" target="_blank"> <FiMail /> contact@ondiagram.com</a>
          .
        </div>
      </Container>
    </PricingSectionWrapper>
  );
};

export default Pricing;
